import { getFullPath } from 'src/routes/Checkout/utils/globalUtils';
import OrderSuccess from '../../../../routes/OrderSuccess';
import { PAGES } from '../../../../store/constants';
import Client from '../../routes/Client';
import Package from '../../routes/Package';
import Services from '../../routes/Services';
import Tourists from '../../routes/Tourists';

const pagesComponents = {
  Package,
  Tourists,
  Services,
  Client,
  OrderSuccess,
};

/**
 * Возвращает компонент из описания маршрутов
 */
const getComponent = (name) => pagesComponents[name] || null;

export const routesList = PAGES.map((item) => ({
  ...item,
  component: getComponent(item.component),
  nextPage: getComponent(item.nextPage),
}));

/**
 * @param step Текущий шаг
 * @returns {string} flights | tourists | services
 */
export const getCheckoutStep = (step: string): string | undefined =>
  PAGES.filter((page) => page.component !== 'OrderSuccess')
    .map((page) =>
      page.component === 'Package' ? { ...page, component: 'flights' } : page,
    )
    .find(({ path: somePath }) => getFullPath(somePath) === step)
    ?.component.toLowerCase();
